import styled from "styled-components"

export const BillingHistoryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px 10px 0;
`
export const HistoryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
`
export const HistoryTitleWrapper = styled.div`
    width: 100%;
    position: relative;
    padding: 10px;
    background: ${(props) => props.theme.billingHistoryTitleBackground};
    border: 1px solid ${(props) => props.theme.billingHistoryBorderColor};
    border-bottom: none;
`
export const HistoryBodyWrapper = styled.div`
    width: 100%;
    padding: 5px 10px 5px 80px;
    background: ${(props) => props.theme.billingHistoryBodyBackground};
    border: 1px solid ${(props) => props.theme.billingHistoryBorderColor};
    border-top: none;
`
export const HistoryItem = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 12px;
    margin: 10px 0;
    border-radius: 2px;
    background: ${(props) => props.theme.billingHistoryItemBackground};
`
export const HistoryItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    line-height: 24px;
    color: ${(props) => props.theme.billingHistoryItemInfoColor};
`
export const HistoryItemTitle = styled.div`
    font-family: ${(props) => props.theme.openSans};
    font-size: 16px;
    color: ${(props) => props.theme.billingHistoryItemTitleColor};
`
export const HistoryTotalPrice = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 0 10px;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.openSans};
    font-size: 18px;
    color: ${(props) => props.theme.billingHistoryPriceColor};
`
export const HistoryItemPrice = styled(HistoryTotalPrice)`
    font-size: 15px;
`
